import { DateTime } from "ts-luxon";
import { MatInputModule } from "@angular/material/input";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { Component, forwardRef, ViewEncapsulation, input } from "@angular/core";
import { NgxMatTimepickerFormatType, NgxMatTimepickerModule } from "ngx-mat-timepicker";

import { ValidationHandlerPipe } from "../../pipes";
import { ReactiveFormsBaseComponent } from "../../base-components";

@Component({
  selector: "app-timepicker",
  standalone: true,
  imports: [ReactiveFormsModule, MatInputModule, NgxMatTimepickerModule, ValidationHandlerPipe],
  templateUrl: "./timepicker.component.html",
  styleUrl: "./timepicker.component.scss",
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimepickerComponent),
      multi: true,
    },
  ],
})
export class TimepickerComponent extends ReactiveFormsBaseComponent {
  readonly format = input<NgxMatTimepickerFormatType>(24);
  readonly minTime = input<string | DateTime>();
  readonly maxTime = input<string | DateTime>();
}
